/* RESPONSIBLE TEAM: team-ai-insights */

export interface TextBlock {
  type: string;
  text: string;
}

const BULLET_PATTERN = /[-•]\s+/;
const BULLET_START_PATTERN = /^\s*[-•]\s+/;
const BULLET_SPLIT_PATTERN = /(?=\s*[-•]\s+)/;

export function textToBlocks(text: string | null | undefined): TextBlock[] {
  if (!text) {
    return [{ type: 'paragraph', text: '' }];
  }

  let lines = text.split('\n').filter((line) => line.trim() !== '');

  if (lines.length === 0) {
    return [{ type: 'paragraph', text: '' }];
  }

  let blocks: TextBlock[] = [];

  lines.forEach((line) => {
    let trimmedLine = line.trim();

    if (BULLET_PATTERN.test(trimmedLine)) {
      let parts = trimmedLine.split(BULLET_SPLIT_PATTERN);

      parts.forEach((part) => {
        let trimmedPart = part.trim();
        if (!trimmedPart) {
          return;
        }

        if (BULLET_START_PATTERN.test(trimmedPart)) {
          let bulletText = trimmedPart.replace(BULLET_START_PATTERN, '').trim();
          if (bulletText) {
            addParagraphBlock(blocks, `• ${bulletText}`);
          }
        } else {
          addParagraphBlock(blocks, trimmedPart);
        }
      });
    } else {
      addParagraphBlock(blocks, trimmedLine);
    }
  });

  return blocks.length > 0 ? blocks : [{ type: 'paragraph', text }];
}

function addParagraphBlock(blocks: TextBlock[], text: string): void {
  blocks.push({
    type: 'paragraph',
    text,
  });
}
